export default __webpack_public_path__ + "static/media/imsaLoader.0040edb5.gif";